import { Button, useMediaQuery } from '@material-ui/core'
import React from 'react'
import { string, func, oneOfType, object } from 'prop-types'
import { useHistory } from 'react-router-dom'

const ButtonLink = props => {
  const history = useHistory()

  const onClick = event => {
    if (props.onClick) props.onClick(event)
    if (props.to) history.push(props.to)
  }

  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <Button
      color='primary'
      size={isMobile ? 'small' : 'medium'}
      {...props}
      onClick={onClick}
    />
  )
}

ButtonLink.propTypes = {
  className: string,
  onClick: func,
  to: oneOfType([string, object])
}

export default ButtonLink
